import React from "react";
import cx from "classnames";
import { useTranslate } from "hooks";
import { ProductImagesPreview } from "./ProductImagesPreview";
import s from "components/ProductConfigurator/ProductConfigurator.module.scss";
import stylesMain from "components/ProductConfigurator/components/Results/components/ProductConfigurationResultMainView.module.scss";
import { ExpandableSection } from "../Results/components/ExpandableSection";
import { Open3dViewButton } from "./Open3dViewButton";
import { useDeviceType } from "components/Layout/useDeviceType";

export const ProductMedia = () => {
  const translate = useTranslate();
  const deviceType = useDeviceType();

  return (
    <div
      className={cx(
        stylesMain.mediaCell,
        "min-h-0 d-flex flex-column bg-white ms-0 mb-xxl-0 flex-shrink-0",
        { "w-100": deviceType !== "desktop" },
      )}
    >
      <ExpandableSection
        title={translate.stringOnly("PRODUCT_CONFIGURATOR_MEDIA")}
        classNames="d-flex flex-column h-100"
        shouldHaveMaximizeBtn={false}
      >
        <div
          className={cx(
            "d-flex flex-column flex-grow-1 min-h-0 overflow-hidden",
            s.mediaWrapper,
          )}
        >
          <div className="flex-grow-1 mb-3 min-h-0 overflow-hidden">
            <ProductImagesPreview carousel />
          </div>

          <div className={s.bottomButton}>
            <Open3dViewButton />
          </div>
        </div>
      </ExpandableSection>
    </div>
  );
};
